module.exports = __webpack_public_path__ + "static/media/3.670eb939.png";